import { render, staticRenderFns } from "./SdkReferensId.vue?vue&type=template&id=0065523a&"
import script from "./SdkReferensId.vue?vue&type=script&lang=js&"
export * from "./SdkReferensId.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports